export const fetchOptionBasedOnRegion = (
  region: string,
  option: SuburbOption,
) => {
  const { name, state, zipcode, postalCode } = option

  switch (region) {
    case 'australia':
    case 'new_zealand':
      if (state) {
        return `${name}, ${state}`
      }
      return `${name}`
    case 'united_states':
      if (state) {
        return `${name}, ${state} ${zipcode}`
      }
      return `${name}`
    case 'canada':
      if (state && !postalCode) {
        return `${name}, ${state}`
      } else if (state) {
        return `${name}, ${state}, ${postalCode}`
      }
      return `${name}`
    default:
      return `${name}`
  }
}

export const checkOptionValueBasedOnRegion = (
  option: SuburbOption,
  value: SuburbOption,
  region: string,
) => {
  switch (region) {
    case 'australia':
    case 'new_zealand':
      if (option.name === value.name) {
        // this is for aus prod region , there seems to be suburb with same name for different states
        return option.state === value.state
      }
      return option.name === value.name
    case 'united_states':
      if (option.zipcode === value.zipcode) {
        return option.name === value.name
      }
      return option.zipcode === value.zipcode
    default:
      return option.postalCode === value.postalCode
  }
}

export const getFormattedInputValue = (
  region: string,
  inputValue: string,
): string => {
  return region === 'canada'
    ? inputValue.replace(/^([A-Za-z]\d[A-Za-z])[ ](\d[A-Za-z]\d)$/g, '$1$2')
    : inputValue
}
